/*
  Much of the vendor save UI is in the AP Automation 
  so we want to share it here
*/
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import update from 'immutability-helper';
import classNames from 'classnames';
import moment from 'moment';
import accounting from 'accounting';

// material
import { CircularProgress, IconButton } from '@material-ui/core';
import OpenLink from '@material-ui/icons/OpenInNew';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

// ui - form
import FMPText from '../../components/pureForm/FMPText';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPCarrierSelect from '../../components/pureForm/FMPCarrierSelect';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import FMPQuickbooksTermSelect from '../../components/pureForm/FMPQuickbooksTermSelect';
import FMPSupplierSelect from '../../components/pureForm/FMPSupplierSelect';

import FMPCheckbox from '../../components/pureForm/FMPCheckbox';
import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import FMPQuickbooksFuelItemSelect from '../../components/pureForm/FMPQuickbooksFuelItemSelect';
import FMPQuickbooksFreightAccountSelect from '../../components/pureForm/FMPQuickbooksFreightAccountSelect';

// misc
import { post } from '../../modules/utility';
import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import BlueQuestion from '../../images/icons/blueQuestionMark.svg';

import { getSharedStyles } from '../../themes';
import { statusClassNames } from '../../libs/utility';
import { valueToAbbreviation } from '../../libs/products';
import { getDocuments } from '../accounting/general';

export const vendorStyles = (theme) => {
	return {
		...getSharedStyles(theme),
		...statusClassNames,
		paper: {
			width: '100%',
			//overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: `30px 10px 30px 10px`,
			paddingBottom: 30,
			marginTop: 5,
			[theme.breakpoints.up('md')]: {
				padding: '20px 20px 40px 20px',
			},
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
			marginTop: 15,
		},
		addInputButton: {
			borderRadius: '100px',
		},

		addLineItem: {
			borderRadius: '100px',
		},
		addOrder: {
			borderRadius: '100px',
			fontSize: 16,
		},
		searchResultContainer: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#333',
			marginTop: 15,
		},
		searchOrTransfer: {
			margin: '5px 0px',
			color: '#777',
		},
		transferContainer: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#333',
			marginTop: 0,
		},
		orderGroup: {
			borderLeft: '4px solid #ccc',
			marginTop: 10,
			paddingLeft: 10,
		},
		orderGroupSpacer: {
			paddingBottom: 40,
			borderBottom: '2px dashed #bbb',
			marginBottom: 30,
		},
		lineItemGroup: {
			borderLeft: '3px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
			marginLeft: 0,
			paddingLeft: 5,
		},
		orderTitle: {
			margin: '50px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			letterSpacing: 1,
			fontFamily: `Roboto,sans-serif`,
			color: '#999',
			fontWeight: 100,
			fontSize: 28,
			display: 'flex',
			[theme.breakpoints.up('md')]: {
				fontSize: 40,
			},
			borderBottom: '1px solid #eee',
		},
		orLine: {
			width: '100%',
			textAlign: 'center',
			borderBottom: '1px solid #bbb',
			color: '#bbb',
			lineHeight: '0.1em',
			margin: '20px 0 10px 0px',
		},
		orBlock: {
			backgroundColor: '#fff',
			padding: '0px 10px',
		},
		addAnotherOrderContainer: {},
		matchTitle: {
			fontSize: 20,
		},
		matchStatusIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
		},
		matchStatusGood: {
			backgroundImage: `url('${GreenChecked}')`,
		},
		matchStatusWarning: {
			backgroundImage: `url('${YellowWarning}')`,
		},
		matchStatusZero: {
			backgroundImage: `url('${BlueQuestion}')`,
		},
		matchTitleContainer: {
			display: 'flex',
			alignItems: 'center',
		},
		matchMessage: {
			fontSize: 16,
			padding: 20,
			paddingTop: 10,
			paddingLeft: 0,
		},
		invoiceContainer: {
			marginBottom: 10,
			paddingBottom: 10,
			borderBottom: '1px solid #bbb',
		},
		sectionContainer: {
			marginBottom: 15,
			paddingLeft: 32,
		},
		sectionLabel: {
			textTransform: 'uppercase',
			color: '#666',
		},
		documentContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			borderBottom: '1px solid #F1F1F1',
			paddingBottom: 7,
			marginBottom: 7,
			marginLeft: 10,
			marginTop: 10,
		},
		documentMatches: {
			padding: 10,
			marginLeft: '0px',
			border: '1px solid rgba(76, 175, 80, .6)',
			backgroundColor: 'rgba(76, 175, 80, .1)',
		},
		documentInfoContainer: {
			display: 'flex',
			justifyContent: 'flex-start',
		},
		documentInfo: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		documentIcons: {
			whiteSpace: 'nowrap',
		},
		documentName: {
			fontWeight: 900,
		},
		totalLine: {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
		orderTotal: {
			fontSize: 24,
		},
		lineAmount: {
			paddingRight: 10,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-end',
			fontSize: 20,
		},
		alreadyLinked: {
			fontSize: 20,
		},
		alreadyLinkedIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			backgroundImage: `url('${YellowWarning}')`,
		},
		billTotalContainer: {
			textAlign: 'right',
			fontSize: 24,
			margin: '40px 0px 10px 0px',
		},
		billTotalLabel: {
			color: '#666',
			textTransform: 'uppercase',
			marginRight: 10,
			fontSize: '80%',
		},
		billTotalValue: {
			fontWeight: 400,
		},
	};
};

function getOrderGroupColor(i) {
	return [
		'#B39DDB',
		'#F48FB1',
		'#FFCC80',
		'#E6EE9C',
		'#80CBC4',
		'#81D4FA',
		'#9FA8DA',
		'#CE93D8',
		'#FFAB91',
	][i % 9];
}

export function getTermsFromCarrier({ newState, carrierId }) {
	const { carriers, quickbooksVendorMap, showErrors } = this.props;

	const carrier = _.find(carriers, { carrierId });
	if (!carrier) {
		return;
	}
	const { billingQuickbooksVendorId } = carrier;

	if (!quickbooksVendorMap) {
		return showErrors(['VendorMap is empty']);
	}

	const quickbooksVendor = quickbooksVendorMap[billingQuickbooksVendorId];
	if (!quickbooksVendor) {
		return showErrors([
			`Vendor not found for this carrier Vendor ID : ${billingQuickbooksVendorId}`,
		]);
	}

	newState.quickbooksVendorId = billingQuickbooksVendorId;
	const customerQuickbooksTermId = _.get(quickbooksVendor, ['TermRef', 'value']);
	if (customerQuickbooksTermId) {
		newState.quickbooksTermId = customerQuickbooksTermId;
	} else {
		console.warn('Vendor did not have a salesTermRef');
	}
}

export function getTermsFromSupplier({ newState, supplierId }) {
	//const { quickbooksTermId } = this.state;
	//if (quickbooksTermId) { return;}
	const { suppliers, quickbooksVendorMap, showErrors } = this.props;

	const supplier = _.find(suppliers, { supplierId });
	if (!supplier) {
		return;
	}
	const { billingQuickbooksVendorId } = supplier;

	if (!quickbooksVendorMap) {
		return showErrors(['VendorMap is empty']);
	}

	const quickbooksVendor = quickbooksVendorMap[billingQuickbooksVendorId];

	if (!quickbooksVendor) {
		return showErrors(
			`Vendor not found for this supplier Vendor ID : ${billingQuickbooksVendorId}`
		);
	}

	newState.quickbooksVendorId = billingQuickbooksVendorId;
	const customerQuickbooksTermId = _.get(quickbooksVendor, ['TermRef', 'value']);
	if (customerQuickbooksTermId) {
		newState.quickbooksTermId = customerQuickbooksTermId;
	}
}

export function searchForInvoiceMatch({ orderIndex, noSet }) {
	const { showErrors } = this.props;
	const { vendorBillOrders, typeOfBill, supplierId, carrierId } = this.state;

	const vendorBillOrder = vendorBillOrders[orderIndex];
	if (!vendorBillOrder) {
		return showErrors(['Vendor Bill Order not found.']);
	}

	const params = {};
	let method = '';
	if (typeOfBill === 'fuel') {
		params.bolNumber = vendorBillOrder.bolNumber;
		params.supplierId = supplierId;
		method = 'bolNumberToInvoice.search';
	} else if (typeOfBill === 'freight') {
		method = 'carrierPoNumberToInvoice.search';
		params.carrierPoNumber = vendorBillOrder.carrierPoNumber;
		params.carrierId = carrierId;
	} else {
		return showErrors(['Pick type of bill first']);
	}

	this.setState((currentState) => {
		const { isSearchingForOrder } = currentState;
		const newIsSearchingForOrder = update(isSearchingForOrder, {
			[orderIndex]: { $set: true },
		});
		return { isSearchingForOrder: newIsSearchingForOrder };
	});

	post({
		method,
		params,
		callback: (err, searchResult) => {
			if (err) {
				showErrors(err);

				this.setState((currentState) => {
					const { isSearchingForOrder } = currentState;
					return {
						isSearchingForOrder: update(isSearchingForOrder, { [orderIndex]: { $set: false } }),
					};
				});
				return;
			}

			// If no invoice results and it's a fuel bill, try railcar BOL lookup as fallback
			const hasInvoiceResults =
				!_.isEmpty(_.get(searchResult, ['bolNumberToInvoiceIds'])) ||
				!_.isEmpty(_.get(searchResult, ['carrierPoNumberToInvoiceIds']));

			if (typeOfBill === 'fuel' && !hasInvoiceResults && vendorBillOrder.bolNumber) {
				post({
					method: 'railcar.search',
					params: { bolNumbers: [vendorBillOrder.bolNumber], supplierId },
					callback: (railcarErr, railcarResult) => {
						const railcars = _.get(railcarResult, ['collections', 'railcarCollection'], []);

						const setFinalResult = (finalResult) => {
							this.setState((currentState) => {
								const { searchResultsForOrder, isSearchingForOrder, vendorBillOrders } =
									currentState;
								const newIndex = {
									bolNumberToInvoiceIds: { $set: [] },
									carrierPoNumberToInvoiceIds: { $set: [] },
									linkedRailcarId: { $set: undefined },
								};
								if (!noSet) {
									newIndex.bolNumberToInvoiceIdHash = { $set: {} };
									newIndex.carrierPoNumberToInvoiceIdHash = { $set: {} };
								}
								return {
									vendorBillOrders: update(vendorBillOrders, { [orderIndex]: newIndex }),
									isSearchingForOrder: update(isSearchingForOrder, {
										[orderIndex]: { $set: false },
									}),
									searchResultsForOrder: update(searchResultsForOrder, {
										[orderIndex]: { $set: finalResult },
									}),
								};
							});
						};

						if (!railcarErr && !_.isEmpty(railcars)) {
							const railcarIds = railcars.map((r) => r.railcarId);
							post({
								method: 'railcar.getLinkedVendorBillOrderIds',
								params: { railcarIds },
								callback: (linkedErr, linkedResult) => {
									const linkedVendorBillOrderMap = _.get(
										linkedResult,
										'linkedVendorBillOrderMap',
										{}
									);
									const annotatedRailcars = railcars.map((r) => ({
										...r,
										linkedVendorBillOrderId:
											linkedVendorBillOrderMap[r.railcarId] || null,
									}));
									const collections = {
										...railcarResult.collections,
										railcarCollection: annotatedRailcars,
									};
									setFinalResult({ type: 'railcar', collections });
								},
							});
							return;
						}

						setFinalResult(searchResult);
					},
				});
				return;
			}

			this.setState((currentState) => {
				const { searchResultsForOrder, isSearchingForOrder, vendorBillOrders } = currentState;

				const newIndex = {
					bolNumberToInvoiceIds: { $set: [] },
					carrierPoNumberToInvoiceIds: { $set: [] },
					//bolNumberToInvoiceIdHash: { $set: {} },
					//carrierPoNumberToInvoiceIdHash: { $set: {} },
				};

				if (!noSet) {
					newIndex.bolNumberToInvoiceIdHash = { $set: {} };
					newIndex.carrierPoNumberToInvoiceIdHash = { $set: {} };
				}

				return {
					vendorBillOrders: update(vendorBillOrders, {
						[orderIndex]: newIndex,
					}),
					isSearchingForOrder: update(isSearchingForOrder, { [orderIndex]: { $set: false } }),
					searchResultsForOrder: update(searchResultsForOrder, {
						[orderIndex]: { $set: searchResult },
					}),
				};
			});
		},
	});
}

//
// RENDER
//

export function renderBillFields() {
	const { classes, suppliers, carriers, quickbooksTerms } = this.props;

	const carrierOptions = _.sortBy(carriers, 'name').filter((carrier) => {
		return !!carrier.billingQuickbooksVendorId;
	});

	const supplierOptions = _.sortBy(suppliers, 'name').filter((supplier) => {
		return !!supplier.billingQuickbooksVendorId;
	});

	const { typeOfBill } = this.state;

	return (
		<Fragment>
			<FMPSectionHeader label={'Bill Info'} />

			{typeOfBill === 'fuel' && (
				<FMPSupplierSelect
					{...this.setForm('supplierId')}
					suppliers={supplierOptions}
					label={'Supplier Vendor'}
					helpText={'Only shows suppliers linked to QB'}
				/>
			)}

			{typeOfBill === 'freight' && (
				<FMPCarrierSelect
					{...this.setForm('carrierId')}
					carriers={carrierOptions}
					label={'Carrier Vendor'}
					helpText={'Only shows carriers linked to QB'}
				/>
			)}

			<FMPQuickbooksTermSelect
				{...this.setForm('quickbooksTermId')}
				quickbooksTerms={quickbooksTerms}
			/>

			<FMPDatePicker {...this.setForm('billDate')} label={'Bill Date'} />

			<FMPText {...this.setForm(`billNumber`)} label={'Bill Number'} />

			{this.renderOrders()}

			{typeOfBill === 'fuel' && (
				<div className={classes.addAnotherOrderContainer}>
					<Button variant="contained" className={classes.addOrder} onClick={() => this.addOrder()}>
						ADD ANOTHER ORDER
					</Button>
				</div>
			)}

			{this.renderBillTotal()}
		</Fragment>
	);
}

export function renderBillTotal() {
	const { classes } = this.props;
	const { vendorBillOrders } = this.state;

	let billTotal = 0;
	vendorBillOrders.forEach((vendorBillOrder) => {
		const { vendorBillOrderLineItems } = vendorBillOrder;
		if (_.isEmpty(vendorBillOrderLineItems)) {
			return;
		}

		vendorBillOrderLineItems.forEach((vendorBillOrderLineItem) => {
			if (!_.isObject(vendorBillOrderLineItem)) {
				return;
			}
			const { quantity, unitPrice, amount } = vendorBillOrderLineItem;
			if (quantity && unitPrice) {
				billTotal += accounting.unformat(accounting.formatMoney(quantity * unitPrice));
			} else if (amount) {
				billTotal += accounting.unformat(accounting.formatMoney(amount));
			}
		});
	});

	return (
		<div className={classes.billTotalContainer}>
			<span className={classes.billTotalLabel}>Bill Total</span>
			<span className={classes.billTotalValue}>{accounting.formatMoney(billTotal)}</span>
		</div>
	);
}

export function renderOrders() {
	const { classes } = this.props;

	const { typeOfBill, supplierId, carrierId, vendorBillOrders } = this.state;

	let isSearchDisabled = false;
	let searchDisabledText;
	if (typeOfBill === 'freight') {
		if (!carrierId) {
			isSearchDisabled = true;
			searchDisabledText = 'Carrier required';
		}
	} else if (typeOfBill === 'fuel') {
		if (!supplierId) {
			isSearchDisabled = true;
			searchDisabledText = 'Supplier required';
		}
	} else {
		isSearchDisabled = true;
	}

	return vendorBillOrders.map((vendorBillOrder, orderIndex) => {
		const orderGroupColor = getOrderGroupColor(orderIndex);
		const prefix = `vendorBillOrders[${orderIndex}]`;

		return (
			<Fragment key={orderIndex}>
				<div className={classes.orderGroup} style={{ borderColor: orderGroupColor }}>
					<div className={classes.orderTitle}>
						<div>Order #{orderIndex + 1}</div>

						{vendorBillOrders.length > 1 && (
							<IconButton
								style={{ color: 'rgba(0, 0, 0, 0.5)' }}
								onClick={() => this.removeOrder({ orderIndex })}
							>
								<DeleteIcon />
							</IconButton>
						)}
					</div>
					<Grid container spacing={3}>
						{typeOfBill === 'fuel' && (
							<FMPText
								{...this.setForm(`${prefix}.bolNumber`)}
								label={'BOL Number'}
								contained={false}
								md={9}
								helpText={searchDisabledText}
							/>
						)}

						{typeOfBill === 'freight' && (
							<FMPText
								{...this.setForm(`${prefix}.carrierPoNumber`)}
								label={'Carrier PO Number'}
								contained={false}
								md={9}
								helpText={searchDisabledText}
							/>
						)}

						<Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
							<Button
								variant="outlined"
								color="primary"
								className={classes.addInputButton}
								onClick={() => this.searchForInvoiceMatch({ orderIndex })}
								disabled={isSearchDisabled}
							>
								SEARCH
							</Button>
						</Grid>

						<Grid item xs={12}>
							<div className={classes.searchResultContainer}>
								{this.renderSearchResultOrCurrentLinkage({
									vendorBillOrder,
									orderIndex,
								})}
							</div>
							<div className={classes.searchOrTransfer}>- or -</div>
							<div className={classes.transferContainer}>
								{this.renderMarkTransfer({
									vendorBillOrder,
									orderIndex,
								})}
							</div>
						</Grid>

						{typeOfBill === 'fuel' && (
							<Grid item xs={12}>
								{this.renderFuelLineItems({ orderIndex })}
							</Grid>
						)}

						{typeOfBill === 'freight' && (
							<Grid item xs={12}>
								{this.renderFreightLineItems({ orderIndex })}
							</Grid>
						)}
					</Grid>
				</div>
				<div className={classes.orderGroupSpacer} />
			</Fragment>
		);
	});
}

renderMarkTransfer.propTypes = {
	orderIndex: PropTypes.number,
};

export function renderMarkTransfer({ orderIndex }) {
	const { typeOfBill } = this.state;

	if (!typeOfBill) {
		return <div>Select type of bill first</div>;
	}

	const deprecatedDiv = (
		<div>
			<strong>DEPRECATED AS OF 1/1/22</strong>
			<br />
			<div style={{ padding: 10 }}>
				This checkbox should not be used anymore on bills dating after 1/1/2022. All PO # or BOL #
				should now all be in the FMP system and ready for matching. Depending on the delivery the
				match will either be a station invoice, a bulk invoice or a rack transfer.
			</div>
		</div>
	);

	const prefix = `vendorBillOrders[${orderIndex}]`;
	if (typeOfBill === 'freight') {
		return (
			<Fragment>
				{deprecatedDiv}
				<FMPCheckbox
					{...this.setForm(`${prefix}.isRackToRackTransfer`)}
					label={'Mark as "Rack to Rack Transfer"'}
					value={`${prefix}.isRackToRackTransfer`}
				/>

				<FMPText
					{...this.setForm(`${prefix}.linkedBulkDeliveryId`)}
					label={'Linked Bulk Delivery #'}
					helpText={`Leave blank if you don't know`}
				/>
			</Fragment>
		);
	} else if (typeOfBill === 'fuel') {
		return (
			<Fragment>
				{deprecatedDiv}
				<FMPCheckbox
					{...this.setForm(`${prefix}.isInventoryTransfer`)}
					label={'Mark as "Rack to Rack Transfer"'}
					value={`${prefix}.isInventoryTransfer`}
				/>
			</Fragment>
		);
	} else {
		return <div>Invalid type of bill : {typeOfBill}</div>;
	}
}

renderSearchResultOrCurrentLinkage.propTypes = {
	vendorBillOrder: PropTypes.number,
	orderIndex: PropTypes.number,
};

export function renderSearchResultOrCurrentLinkage({ vendorBillOrder, orderIndex }) {
	const { typeOfBill, searchResultsForOrder, isSearchingForOrder, isUpdate } = this.state;

	if (!typeOfBill) {
		return <div>Select type of bill then search</div>;
	}

	if (isSearchingForOrder[orderIndex]) {
		return (
			<div>
				<CircularProgress /> Search records...
			</div>
		);
	}

	let bolNumberToInvoiceIds, carrierPoNumberToInvoiceIds, linkedRailcarId, vendorBillOrderId;
	if (_.isObject(vendorBillOrder)) {
		({ vendorBillOrderId, bolNumberToInvoiceIds, carrierPoNumberToInvoiceIds, linkedRailcarId } =
			vendorBillOrder);
	}

	const {
		bolNumberToInvoiceMap,
		carrierPoNumberToInvoiceMap,
		stationInvoiceMap,
		bulkInvoiceMap,
		rackTransferMap,
		stationDeliveryMap,
		stationMap,
		carrierMap,
		terminalMap,
		supplierMap,
		invoiceDocumentMap,
		resourceMap,
		bulkCustomerMap,
		bulkDeliveryMap,
	} = this.props;

	const searchResult = searchResultsForOrder[orderIndex];
	if (!_.isUndefined(searchResult)) {
		return renderSearchResult.call(this, {
			orderIndex,
			vendorBillOrderId,
		});
	} else if (isUpdate && !_.isEmpty(bolNumberToInvoiceIds)) {
		return (
			<Fragment>
				{bolNumberToInvoiceIds.map((bolNumberToInvoiceId, invoiceIndex) => {
					const bolNumberToInvoice = bolNumberToInvoiceMap[bolNumberToInvoiceId];
					return this.renderInvoiceDetails({
						bolNumberToInvoice,
						orderIndex,
						vendorBillOrderId,
						invoiceIndex,
						stationInvoiceMap,
						bulkInvoiceMap,
						rackTransferMap,
						stationDeliveryMap,
						bulkDeliveryMap,
						stationMap,
						bulkCustomerMap,
						carrierMap,
						terminalMap,
						supplierMap,
						invoiceDocumentMap,
						resourceMap,
					});
				})}
			</Fragment>
		);
	} else if (isUpdate && !_.isEmpty(carrierPoNumberToInvoiceIds)) {
		return (
			<Fragment>
				{carrierPoNumberToInvoiceIds.map((carrierPoNumberToInvoiceId, invoiceIndex) => {
					const carrierPoNumberToInvoice = carrierPoNumberToInvoiceMap[carrierPoNumberToInvoiceId];
					return this.renderInvoiceDetails({
						carrierPoNumberToInvoice,
						orderIndex,
						vendorBillOrderId,
						invoiceIndex,
						stationInvoiceMap,
						bulkInvoiceMap,
						rackTransferMap,
						stationDeliveryMap,
						bulkDeliveryMap,
						stationMap,
						bulkCustomerMap,
						carrierMap,
						terminalMap,
						supplierMap,
						invoiceDocumentMap,
						resourceMap,
					});
				})}
			</Fragment>
		);
	} else if (isUpdate && linkedRailcarId) {
		const railcar = this.props.railcarMap && this.props.railcarMap[linkedRailcarId];
		return renderLinkedRailcarDetails.call(this, { railcar, linkedRailcarId, orderIndex });
	} else {
		return <div>Search to see matching invoices...</div>;
	}
}

renderSearchResult.propTypes = {
	vendorBillOrderId: PropTypes.number,
	orderIndex: PropTypes.number,
};
export function renderSearchResult({ vendorBillOrderId, orderIndex }) {
	const { classes } = this.props;
	const { typeOfBill, searchResultsForOrder, isSearchingForOrder } = this.state;

	if (!typeOfBill) {
		return <div>Select type of bill then search</div>;
	}

	if (isSearchingForOrder[orderIndex]) {
		return (
			<div>
				<CircularProgress /> Search records...
			</div>
		);
	}

	const searchResult = searchResultsForOrder[orderIndex];
	if (_.isUndefined(searchResult)) {
		return <div>Search to see matching invoices...</div>;
	}

	//- Might want the typeOfBill se we can render differently

	// Railcar search result
	if (searchResult.type === 'railcar') {
		const railcars = _.get(searchResult, ['collections', 'railcarCollection'], []);
		if (_.isEmpty(railcars)) {
			return <div>No railcar found for this BOL number.</div>;
		}
		return renderRailcarSearchResults.call(this, { railcars, orderIndex, vendorBillOrderId });
	}

	const { bolNumberToInvoiceIds, carrierPoNumberToInvoiceIds } = searchResult;

	if (_.isEmpty(bolNumberToInvoiceIds) && _.isEmpty(carrierPoNumberToInvoiceIds)) {
		return <div>No invoice or railcar found for this BOL number.</div>;
	}

	const bulkInvoices = [];
	const rackTransfers = [];
	const stationInvoices = [];
	const c = searchResult.collections;
	const bulkInvoiceMap = _.keyBy(_.get(c, 'bulkInvoiceCollection', []), 'bulkInvoiceId');
	const rackTransferMap = _.keyBy(_.get(c, 'rackTransferMapCollection', []), 'rackTransferId');
	const stationInvoiceMap = _.keyBy(_.get(c, 'stationInvoiceCollection', []), 'stationInvoiceId');
	const carrierPoNumberToInvoices = _.get(c, 'carrierPoNumberToInvoiceCollection', []);
	const bolNumberToInvoices = _.get(c, 'bolNumberToInvoiceCollection', []);

	if (!_.isEmpty(carrierPoNumberToInvoices)) {
		carrierPoNumberToInvoices.forEach((carrierPoNumberToInvoice) => {
			const { stationInvoiceId, bulkInvoiceId, rackTransferId } = carrierPoNumberToInvoice;

			if (stationInvoiceId) {
				stationInvoices.push(stationInvoiceMap[stationInvoiceId]);
			} else if (bulkInvoiceId) {
				bulkInvoices.push(bulkInvoiceMap[bulkInvoiceId]);
			} else if (rackTransferId) {
				rackTransfers.push(rackTransferMap[rackTransferId]);
			}
		});
	} else if (!_.isEmpty(bolNumberToInvoices)) {
		bolNumberToInvoices.forEach((bolNumberToInvoice) => {
			const { stationInvoiceId, bulkInvoiceId, rackTransferId } = bolNumberToInvoice;
			if (stationInvoiceId) {
				stationInvoices.push(stationInvoiceMap[stationInvoiceId]);
			} else if (bulkInvoiceId) {
				bulkInvoices.push(bulkInvoiceMap[bulkInvoiceId]);
			} else if (rackTransferId) {
				rackTransfers.push(rackTransferMap[rackTransferId]);
			}
		});
	}
	const totalMatches = bulkInvoices.length + stationInvoices.length + rackTransfers.length;

	//- ITS GOOD
	//- If its a carrierPO number and it matches only one
	//- If its a carrier PO number and it matches two BUT both of those two are from teh same split (STL)
	let matchStatus = 'zero';
	let matchTitle = 'No matches found';
	let matchMessage =
		`No matches found. Double check what you typed in to search. This can be caused` +
		` if the invoice or rack transfer has not been processed yet or the carrier po / bol number was entered ` +
		` incorrectly on the invoice / rack transfer. Please investigate.`;

	if (typeOfBill === 'freight') {
		if (totalMatches === 1) {
			matchStatus = 'good';
			matchTitle = 'Single invoice/rack transfer matched';
			matchMessage = 'Carrier PO Number matched a single invoice/rack transfer. Perfect.';
		} else if (totalMatches === 2) {
			//- analyze these see if they share a linked delivery then it means they re split and its STL
			if (stationInvoices.length === 2) {
				const first = stationInvoices[0];
				const second = stationInvoices[1];
				if (first.linkedStationDeliveryId === second.linkedStationDeliveryId) {
					matchStatus = 'good';
					matchTitle = '2 invoices/transfers from same split delivery matched';
					matchMessage =
						`Matched 2 invoices/transfers and they are both part of the same split ` +
						` load delivery and those sometimes share a carrier po number.`;
				} else {
					matchStatus = 'warning';
					matchTitle = '2 invoices/transfers matched NOT same delivery';
					matchMessage =
						`Matched 2 invoices/transfers but they are NOT part of the same split ` +
						`load  delivery. Did the same PO number accidentally get applied to two invoices?`;
				}
			} else {
				matchStatus = 'warning';
				matchTitle = '2 non station invoices/transfers matched';
				matchMessage = 'Matched multiple non station invoices/rack transfers. Please investigate';
			}
		} else if (stationInvoices.length > 2) {
			matchStatus = 'warning';
			matchTitle = 'Too many invoices/transfers matched';
			matchMessage =
				`Matched too many invoices  / rack transfers. This can be caused by a a PO number being ` +
				` duplicated on a invoice/rack transfer or a typo on an invoice/rack transfer.` +
				` Look at the invoices/rack transfers and find the problem one and try to fix it.`;
		}

		//- If its a BOL number nad it matches one
		//- If it matches TWO let them check both the boxes but it shouldn't - warning
	} else if (typeOfBill === 'fuel') {
		if (totalMatches === 1) {
			matchStatus = 'good';
			matchTitle = 'Single invoice/rack transfer matched';
			matchMessage = 'BOL Number matched a single invoice / rack transfer matched. Perfect.';
		} else if (stationInvoices.length >= 2) {
			matchStatus = 'warning';
			matchTitle = 'Multiple invoices/rack transfers matched';
			matchMessage =
				`Matched too many invoices / rack transfers. This can be caused by a a BOL number being ` +
				` duplicated on an invoice/rack transfer or a typo on an invoice/rack transfers. Look at the invoices ` +
				` / rack transfers and find the problem one and try to fix it. There are VERY rare cases where ` +
				` the BOL number is used on two documents and if that is the case then select both invoices ` +
				` / rack transfers on the vendor bill.`;
		}
	}

	return (
		<div>
			{this.renderMatchStatus({ matchStatus, matchTitle })}
			<div className={classes.matchMessage}>{matchMessage}</div>
			{this.renderInvoiceMatches({
				searchResult,
				orderIndex,
				vendorBillOrderId,
				matchStatus,
			})}
		</div>
	);
}

export function renderMatchStatus({ matchStatus, matchTitle }) {
	const { classes } = this.props;

	if (matchStatus === 'good') {
		return (
			<div className={classes.matchTitleContainer}>
				<div className={classNames(classes.matchStatusIcon, classes.matchStatusGood)} />
				<div className={classes.matchTitle}>{matchTitle}</div>
			</div>
		);
	} else if (matchStatus === 'warning') {
		return (
			<div className={classes.matchTitleContainer}>
				<div className={classNames(classes.matchStatusIcon, classes.matchStatusWarning)} />
				<div className={classes.matchTitle}>{matchTitle}</div>
			</div>
		);
	} else if (matchStatus === 'zero') {
		return (
			<div className={classes.matchTitleContainer}>
				<div className={classNames(classes.matchStatusIcon, classes.matchStatusZero)} />
				<div className={classes.matchTitle}>{matchTitle}</div>
			</div>
		);
	} else {
		return (
			<div className={classes.matchTitleContainer}>
				<div className={classes.matchTitle}>Missing status {matchStatus}</div>
			</div>
		);
	}
}

export function renderInvoiceMatches({ searchResult, vendorBillOrderId, matchStatus, orderIndex }) {
	//- Get all the mapping tables
	//- Might want the typeOfBill se we can render differently

	//- Might want the typeOfBill se we can render differently
	const c = searchResult.collections;
	const carrierPoNumberToInvoices = _.get(c, 'carrierPoNumberToInvoiceCollection', []);
	const bolNumberToInvoices = _.get(c, 'bolNumberToInvoiceCollection', []);
	const bulkInvoiceMap = _.keyBy(_.get(c, 'bulkInvoiceCollection', []), 'bulkInvoiceId');
	const rackTransferMap = _.keyBy(_.get(c, 'rackTransferCollection', []), 'rackTransferId');
	const stationInvoiceMap = _.keyBy(_.get(c, 'stationInvoiceCollection', []), 'stationInvoiceId');
	const stationDeliveryMap = _.keyBy(
		_.get(c, 'stationDeliveryCollection', []),
		'stationDeliveryId'
	);
	const bulkDeliveryMap = _.keyBy(_.get(c, 'bulkDeliveryCollection', []), 'bulkDeliveryId');
	const stationMap = _.keyBy(_.get(c, 'stationCollection', []), 'stationId');
	const carrierMap = _.keyBy(_.get(c, 'carrierCollection', []), 'carrierId');
	const terminalMap = _.keyBy(_.get(c, 'terminalCollection', []), 'terminalId');
	const supplierMap = _.keyBy(_.get(c, 'supplierCollection', []), 'supplierId');
	const invoiceDocumentMap = _.keyBy(
		_.get(c, 'invoiceDocumentCollection', []),
		'invoiceDocumentId'
	);
	const resourceMap = _.keyBy(_.get(c, 'resourceCollection', []), 'resourceId');
	const bulkCustomerMap = _.keyBy(_.get(c, 'bulkCustomerCollection', []), 'bulkCustomerId');
	//const quickbooksCustomerMap = _.map(_.get(c, 'quickbooksCustomerCollection', []), 'quickbooksCustomerId');
	//const quickbooksTermMap = _.map(_.get(c, 'quickbooksTermCollection', []), 'quickbooksTermId');

	if (!_.isEmpty(carrierPoNumberToInvoices)) {
		//const invoices = stationInvoices.concat(bulkInvoices);
		return (
			<Fragment>
				{carrierPoNumberToInvoices.map((carrierPoNumberToInvoice, invoiceIndex) => {
					return this.renderInvoiceDetails({
						carrierPoNumberToInvoice,
						orderIndex,
						vendorBillOrderId,
						invoiceIndex,
						matchStatus,

						bulkInvoiceMap,
						rackTransferMap,
						stationInvoiceMap,
						stationDeliveryMap,
						stationMap,
						carrierMap,
						terminalMap,
						supplierMap,
						invoiceDocumentMap,
						resourceMap,
						bulkCustomerMap,
						bulkDeliveryMap,
					});
				})}
			</Fragment>
		);
	} else if (!_.isEmpty(bolNumberToInvoices)) {
		//const invoices = stationInvoices.concat(bulkInvoices);
		return (
			<Fragment>
				{bolNumberToInvoices.map((bolNumberToInvoice, invoiceIndex) => {
					return this.renderInvoiceDetails({
						bolNumberToInvoice,
						orderIndex,
						vendorBillOrderId,
						invoiceIndex,
						matchStatus,

						bulkInvoiceMap,
						rackTransferMap,
						stationInvoiceMap,
						stationDeliveryMap,
						stationMap,
						carrierMap,
						terminalMap,
						supplierMap,
						invoiceDocumentMap,
						resourceMap,
						bulkCustomerMap,
						bulkDeliveryMap,
					});
				})}
			</Fragment>
		);
	}
}

export function renderRailcarSearchResults({ railcars, orderIndex, vendorBillOrderId }) {
	const { classes, supplierMap } = this.props;
	const { vendorBillOrders } = this.state;
	const currentOrder = vendorBillOrders[orderIndex];
	return (
		<div>
			{railcars.map((railcar) => {
				const {
					railcarId,
					railcarNumber,
					supplierId,
					product,
					netGallons,
					requestedNumber,
					cpDate,
					apDate,
					linkedVendorBillOrderId,
				} = railcar;
				const isSelected = currentOrder && currentOrder.linkedRailcarId === railcarId;
				const alreadyLinked = !!linkedVendorBillOrderId;
				const supplier = supplierMap && supplierMap[supplierId];
				const supplierName = supplier ? supplier.name : supplierId;

				const checkLabel = (
					<div>
						Link to railcar #<strong>{railcarNumber}</strong>
					</div>
				);

				return (
					<div key={railcarId} className={classes.invoiceContainer}>
						{alreadyLinked && (
							<div className={classes.alreadyLinked}>
								<div className={classes.alreadyLinkedIcon} />
								Already linked to another vendor bill
							</div>
						)}
						<FMPCheckbox
							checked={isSelected}
							value={String(railcarId)}
							path={`railcar-${railcarId}`}
							onChange={() => {
								this.setState((currentState) => {
									const { vendorBillOrders } = currentState;
									return {
										vendorBillOrders: update(vendorBillOrders, {
											[orderIndex]: {
												linkedRailcarId: { $set: isSelected ? undefined : railcarId },
											},
										}),
									};
								});
							}}
							disabled={alreadyLinked}
							label={<div style={{ fontSize: 20 }}>{checkLabel}</div>}
						/>
						<div className={classes.sectionContainer}>
							<div className={classes.sectionLabel}>Railcar Info</div>
							<div>
								<div>Railcar # : {railcarNumber}</div>
								<div>Supplier : {supplierName}</div>
								<div>Product : {product}</div>
								{requestedNumber && <div>PO # : {requestedNumber}</div>}
								{cpDate && <div>CP Date : {moment(cpDate).format('ddd, M/D')}</div>}
								{apDate && <div>Date Rec&apos;d : {moment(apDate).format('ddd, M/D')}</div>}
								<div>Net Gallons : {netGallons ? netGallons.toLocaleString() : '—'}</div>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}


export function renderLinkedRailcarDetails({ railcar, linkedRailcarId, orderIndex }) {
	const { classes, supplierMap, terminalMap } = this.props;

	const checkLabel = (
		<div style={{ display: 'flex', alignItems: 'center', color: '#212121' }}>
			Link to railcar #<strong style={{ marginLeft: 4 }}>{railcar ? railcar.railcarNumber : linkedRailcarId}</strong>
			<IconButton
				size="small"
				style={{ marginLeft: 6, color: '#1976d2' }}
				onClick={() => this.props.history.push(`/railcars/view/${linkedRailcarId}`)}
				title="View railcar"
			>
				<OpenLink fontSize="small" />
			</IconButton>
		</div>
	);

	let railcarInfo = null;
	if (railcar) {
		const { railcarNumber, supplierId, terminalId, product, netGallons, requestedNumber, requestedMonth, fuelContractId, cpDate, apDate } = railcar;
		const supplier = supplierMap && supplierMap[supplierId];
		const supplierName = supplier ? supplier.name : supplierId;
		const terminal = terminalMap && terminalMap[terminalId];
		const terminalName = terminal ? terminal.name : null;
		const poDisplay = requestedMonth && requestedNumber
			? `${moment(requestedMonth).format('MMM')} (#${requestedNumber})`
			: requestedNumber || null;
		railcarInfo = (
			<div className={classes.sectionContainer}>
				<div className={classes.sectionLabel}>Railcar Info</div>
				<div>
					<div>Railcar # : {railcarNumber}</div>
					<div>Supplier : {supplierName}</div>
					<div>Product : {product}</div>
					{terminalName && <div>Terminal : {terminalName}</div>}
					{fuelContractId && <div>Contract ID : {fuelContractId}</div>}
					{poDisplay && <div>PO # : {poDisplay}</div>}
					{cpDate && <div>CP Date : {moment(cpDate).format('ddd, M/D')}</div>}
					{apDate && <div>Date Rec&apos;d : {moment(apDate).format('ddd, M/D')}</div>}
					<div>Net Gallons : {netGallons ? netGallons.toLocaleString() : '—'}</div>
				</div>
			</div>
		);
	}

	return (
		<div className={classes.invoiceContainer}>
			<FMPCheckbox
				checked={true}
				value={String(linkedRailcarId)}
				path={`railcar-linked-${linkedRailcarId}`}
				onChange={() => {}}
				disabled={true}
				label={<div style={{ fontSize: 20 }}>{checkLabel}</div>}
			/>
			{railcarInfo}
		</div>
	);
}

export function renderInvoiceDetails(p) {
	const {
		bolNumberToInvoice,
		carrierPoNumberToInvoice,

		stationInvoiceMap,
		bulkInvoiceMap,
		rackTransferMap,
		orderIndex,
		vendorBillOrderId,
		invoiceIndex,
		//matchStatus,

		stationMap,
		bulkDeliveryMap,
		stationDeliveryMap,
		carrierMap,
		supplierMap,
		terminalMap,
		invoiceDocumentMap,
		bulkCustomerMap,
		resourceMap,
	} = p;

	const { classes } = this.props;
	let bolNumberToInvoiceId,
		carrierPoNumberToInvoiceId,
		stationInvoiceId,
		bulkInvoiceId,
		rackTransferId,
		linkedToVendorBillOrderId,
		linkedToVendorBillId;

	let matchingItem = '';
	if (bolNumberToInvoice) {
		({
			bolNumberToInvoiceId,
			linkedToVendorBillOrderId,
			linkedToVendorBillId,
			stationInvoiceId,
			bulkInvoiceId,
			rackTransferId,
		} = bolNumberToInvoice);
		matchingItem = bolNumberToInvoice.bolNumber;
	}
	if (carrierPoNumberToInvoice) {
		({
			carrierPoNumberToInvoiceId,
			linkedToVendorBillOrderId,
			linkedToVendorBillId,
			stationInvoiceId,
			bulkInvoiceId,
			rackTransferId,
		} = carrierPoNumberToInvoice);
		matchingItem = carrierPoNumberToInvoice.carrierPoNumber;
	}

	let stationInvoice, bulkInvoice, rackTransfer;
	if (stationInvoiceId) {
		stationInvoice = stationInvoiceMap[stationInvoiceId];
	} else if (bulkInvoiceId) {
		bulkInvoice = bulkInvoiceMap[bulkInvoiceId];
	} else if (rackTransferId) {
		rackTransfer = rackTransferMap[rackTransferId];
	} else {
		return (
			<div key={`${orderIndex}_${invoiceIndex}`}>
				Invoice missing bulk invoice id, station invoice id, or rack transfer id. Something is
				wrong. Perhaps linkage got changed.
			</div>
		);
	}

	let productType,
		linkedBulkDeliveryId,
		linkedStationDeliveryId,
		stationId,
		bulkCustomerId,
		carrierId,
		invoiceDocumentIds,
		total,
		issueDate;

	let destinationDisplay = '';
	let deliveryInfo = '';
	let bulkDelivery, stationDelivery;

	if (stationInvoice) {
		({
			productType,
			linkedStationDeliveryId,
			stationId,
			carrierId,
			//status,
			invoiceDocumentIds,
			issueDate,
			total,
		} = stationInvoice);

		const station = stationMap[stationId] || { number: '', name: 'MISSING STATION' };
		destinationDisplay = `${station.number} - ${station.name}`;

		//- Delivery
		const productTypeAbbreviation = valueToAbbreviation(productType);
		stationDelivery = stationDeliveryMap[linkedStationDeliveryId];
		if (!stationDelivery) {
			return (
				<span key={stationInvoiceId}>Problem : Delivery {linkedStationDeliveryId} not found</span>
			);
		}

		const { deliveryWindowEndDateTime, stationDeliveryId } = stationDelivery;

		const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
		const dateDisplay = moment(deliveryWindowEndDateTime).format('ddd, M/D');
		deliveryInfo = (
			<Fragment>
				<div>{destinationDisplay}</div>
				<div>Carrier : {carrier.name}</div>
				<div>
					{productTypeAbbreviation} - Station Delivery #{stationDeliveryId} on {dateDisplay}
				</div>
			</Fragment>
		);
	} else if (bulkInvoice) {
		({
			bulkCustomerId,
			linkedBulkDeliveryId,
			carrierId,
			//status,
			//deliveryWindowEndDateTime,
			invoiceDocumentIds,
			issueDate,
			//dateCreated,
			//collatedResourceId,
			//quickbooksInvoiceUrl,
			total,
		} = bulkInvoice);

		const bulkCustomer = bulkCustomerMap[bulkCustomerId] || { name: 'MISSING STATION' };
		destinationDisplay = `${bulkCustomer.name}`;

		//- Delivery
		bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];
		if (!bulkDelivery) {
			return <span key={bulkInvoiceId}>Problem : Delivery {linkedBulkDeliveryId} not found</span>;
		}

		const { deliveryDate, bulkDeliveryId } = bulkDelivery;

		const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
		const dateDisplay = moment(deliveryDate).format('ddd, M/D');
		deliveryInfo = (
			<Fragment>
				<div>{destinationDisplay}</div>
				<div>Carrier : {carrier.name}</div>
				<div>
					Bulk Delivery #{bulkDeliveryId} on {dateDisplay}
				</div>
			</Fragment>
		);
	} else if (rackTransfer) {
		({ bulkCustomerId, linkedBulkDeliveryId, carrierId, invoiceDocumentIds } = rackTransfer);

		const bulkCustomer = bulkCustomerMap[bulkCustomerId] || { name: 'MISSING Customer' };
		destinationDisplay = `${bulkCustomer.name}`;

		//- Delivery
		bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];
		if (!bulkDelivery) {
			return <span key={bulkInvoiceId}>Problem : Delivery {linkedBulkDeliveryId} not found</span>;
		}

		const { deliveryDate, bulkDeliveryId } = bulkDelivery;

		const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
		const dateDisplay = moment(deliveryDate).format('ddd, M/D');
		deliveryInfo = (
			<Fragment>
				<div>{destinationDisplay}</div>
				<div>Carrier : {carrier.name}</div>
				<div>
					Bulk Delivery #{bulkDeliveryId} on {dateDisplay}
				</div>
			</Fragment>
		);
	}

	//- Station Invoice
	const invoiceDocuments = (invoiceDocumentIds || []).map((invoiceDocumentId) => {
		return (
			invoiceDocumentMap[invoiceDocumentId] || {
				name: 'MISSING',
				data: { documentName: 'Missing' },
			}
		);
	});

	const { uploadedInvoiceDocuments } = getDocuments({
		bulkDelivery,
		stationDelivery,
		carrierMap,
		terminalMap,
		supplierMap,
		invoiceDocuments,
	});

	//- Documents
	//let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);
	//const statusDisplay = statusToDisplay[status] || status;
	//let invoicePdf = 'PDF';
	//let onInvoiceClick = () => { this.onInvoiceClick(collatedResourceId); };

	let invoiceInfo;
	if (!rackTransfer) {
		let issueMoment = moment(issueDate);
		let issueDateDisplay = issueMoment.format('ddd, M/D');
		let invoiceTotal = <span>{accounting.formatMoney(total)}</span>;
		invoiceInfo = (
			<Fragment>
				<div>Issued : {issueDateDisplay}</div>
				<div>Total : {invoiceTotal}</div>
			</Fragment>
		);
	}

	let checkPath = '';
	let key;
	if (bolNumberToInvoiceId) {
		key = `${invoiceIndex}_${bolNumberToInvoiceId}`;
		checkPath = `vendorBillOrders.${orderIndex}.bolNumberToInvoiceIdHash.${bolNumberToInvoiceId}`;
	} else if (carrierPoNumberToInvoiceId) {
		key = `${invoiceIndex}_${carrierPoNumberToInvoiceId}`;
		checkPath = `vendorBillOrders.${orderIndex}.carrierPoNumberToInvoiceIdHash.${carrierPoNumberToInvoiceId}`;
	} else {
		return <div>ERROR : ResultRow missing carrierPoNumberToInvoiceId or bolNumberToInvoice</div>;
	}

	let checkLabel;
	let isRackTransfer = false;
	if (stationInvoiceId) {
		checkLabel = (
			<div>
				Link to station invoice #<strong>{stationInvoiceId}</strong>
				<a
					href={`/accounting/stationInvoice/update/${stationInvoiceId}`}
					style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
					target="_blank"
					rel="noreferrer noopener"
				>
					<OpenLink style={{ width: 20, height: 20 }} />
				</a>
			</div>
		);
	} else if (bulkInvoiceId) {
		checkLabel = (
			<div>
				Link to bulk invoice #<strong>{bulkInvoiceId}</strong>
				<a
					href={`/accounting/bulkInvoice/update/${bulkInvoiceId}`}
					style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
					target="_blank"
					rel="noreferrer noopener"
				>
					<OpenLink style={{ width: 20, height: 20 }} />
				</a>
			</div>
		);
	} else if (rackTransferId) {
		checkLabel = (
			<div>
				Link to rack transfer #<strong>{rackTransferId}</strong>
				<a
					href={`/accounting/rackTransfer/update/${rackTransferId}`}
					style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
					target="_blank"
					rel="noreferrer noopener"
				>
					<OpenLink style={{ width: 20, height: 20 }} />
				</a>
			</div>
		);
		isRackTransfer = true;
	}

	//- Check if its already linked
	let disabled = false;
	let alreadyLinked;
	if (linkedToVendorBillOrderId) {
		//- This means its n update
		if (linkedToVendorBillOrderId !== vendorBillOrderId) {
			alreadyLinked = (
				<div className={classes.alreadyLinked}>
					<div className={classes.alreadyLinkedIcon} />
					Already linked to Vendor Bill
					<a
						href={`/billing/vendorBill/update/${linkedToVendorBillId}`}
						style={{ textDecoration: 'none' }}
						target="_blank"
						rel="noreferrer noopener"
					>
						{' '}
						#{linkedToVendorBillId}
					</a>
				</div>
			);
			disabled = true;
		}
	}

	return (
		<div className={classes.invoiceContainer} key={key}>
			{!!alreadyLinked && alreadyLinked}
			<div>
				<FMPCheckbox
					{...this.setForm(checkPath, 'Link to station', false, false)}
					label={<div style={{ fontSize: 20 }}>{checkLabel}</div>}
					///value={checkPath}
					disabled={disabled}
				/>
			</div>
			<div className={classes.sectionContainer}>
				<div className={classes.sectionLabel}>Delivery Info</div>
				<div>{deliveryInfo}</div>
			</div>
			{invoiceInfo && (
				<div className={classes.sectionContainer}>
					<div className={classes.sectionLabel}>Invoice Info</div>
					<div>{invoiceInfo}</div>
				</div>
			)}
			<div className={classes.sectionContainer}>
				<div className={classes.sectionLabel}>
					{isRackTransfer ? 'Rack Transfer' : 'Invoice'} Documents
				</div>
				<div>
					{uploadedInvoiceDocuments.map((invoiceDocument) => {
						const { invoiceDocumentId, name, details, documentType, data } = invoiceDocument;

						let matchingClass = null;
						let bolNumberDisplay;
						if (_.isObject(data)) {
							const { bolNumber, carrierPoNumber } = data;
							if (bolNumber) {
								bolNumberDisplay = `Bol Number : ${bolNumber}`;

								if (matchingItem === bolNumber) {
									matchingClass = classes.documentMatches;
								}
							} else if (carrierPoNumber) {
								if (matchingItem === carrierPoNumber) {
									matchingClass = classes.documentMatches;
								}
							}
						}

						return (
							<div
								className={classNames(classes.documentContainer, matchingClass)}
								key={invoiceDocumentId}
							>
								<div className={classes.documentInfoContainer}>
									<InvoiceDocumentIcon
										invoiceDocument={invoiceDocument}
										resourceMap={resourceMap}
										onClick={() => {
											this.onDocumentClick([invoiceDocument]);
										}}
									/>

									<div className={classes.documentInfo}>
										<div className={classes.documentName}>{name || documentType}</div>
										<div className={classes.documentDetails}>{details}</div>
										{bolNumberDisplay && (
											<div className={classes.documentDetails}>{bolNumberDisplay}</div>
										)}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}

renderFuelLineItems.propTypes = {
	orderIndex: PropTypes.number,
};

export function renderFuelLineItems({ orderIndex }) {
	const { classes } = this.props;
	const prefix = `vendorBillOrders.${orderIndex}.vendorBillOrderLineItems`;
	const vendorBillOrderLineItems = _.get(this.state, prefix, []);

	let orderTotal = 0;
	return (
		<Fragment>
			{vendorBillOrderLineItems.map((vendorBillOrderLineItem, lineItemIndex) => {
				const pathPrefix = `${prefix}.${lineItemIndex}`;
				const isFirst = lineItemIndex === 0;
				let lineAmount = '-';

				const { quantity, unitPrice } = vendorBillOrderLineItem;
				if (quantity && unitPrice) {
					lineAmount = accounting.unformat(accounting.formatMoney(quantity * unitPrice));
					orderTotal += lineAmount;
				}

				return (
					<Grid container spacing={2} key={lineItemIndex} className={classes.lineItemGroup}>
						<Grid item xs={12}>
							{isFirst && <FMPSectionHeader label={`Fuel Line Item`} isTop={true} />}

							{!isFirst && (
								<div style={{ display: 'flex', color: '#666666', alignItems: 'center' }}>
									<FMPSectionHeader label={`Tax Line Item #${lineItemIndex + 1}`} isTop={true} />
									<IconButton
										style={{ color: 'rgba(0, 0, 0, 0.5)' }}
										onClick={() => this.removeLineItem({ orderIndex, lineItemIndex })}
									>
										<DeleteIcon size="small" fontSize="small" />
									</IconButton>
								</div>
							)}
						</Grid>

						<Grid item xs={12} lg={6}>
							<FMPQuickbooksFuelItemSelect
								{...this.setForm(`${pathPrefix}.quickbooksItemId`)}
								showOnlyFuelLineItems={isFirst}
								label={isFirst ? 'QB Fuel Item' : 'QB Tax Item'}
							/>
						</Grid>

						<Grid item xs={12} sm={5} lg={2}>
							<FMPText {...this.setForm(`${pathPrefix}.quantity`)} label={'Quantity'} />
						</Grid>
						<Grid item xs={12} sm={5} lg={2}>
							<FMPText {...this.setForm(`${pathPrefix}.unitPrice`)} label={'Unit price'} />
						</Grid>
						<Grid item xs={12} sm={2} lg={2} className={classes.lineAmount}>
							{accounting.formatMoney(lineAmount)}
						</Grid>
					</Grid>
				);
			})}

			<div className={classes.totalLine}>
				<Button
					variant="outlined"
					className={classes.addLineItem}
					onClick={() => this.addLineItem({ orderIndex })}
				>
					{vendorBillOrderLineItems.length === 1 && <Fragment>Add a tax line item</Fragment>}
					{vendorBillOrderLineItems.length > 1 && <Fragment>Add another tax line item</Fragment>}
				</Button>
				<div className={classes.orderTotal}>{accounting.formatMoney(orderTotal)}</div>
			</div>
		</Fragment>
	);
}

renderFreightLineItems.propTypes = {
	orderIndex: PropTypes.number,
};
export function renderFreightLineItems({ orderIndex }) {
	const { classes } = this.props;
	const prefix = `vendorBillOrders.${orderIndex}.vendorBillOrderLineItems`;
	const vendorBillOrderLineItems = _.get(this.state, prefix, []);

	return (
		<Grid container>
			<Grid item xs={12}>
				<FMPSectionHeader label={`Freight Line Item`} isTop={true} />
			</Grid>
			{vendorBillOrderLineItems.map((vendorBillOrderLineItem, lineItemIndex) => {
				const pathPrefix = `${prefix}.${lineItemIndex}`;
				return (
					<Grid
						container
						spacing={1}
						key={lineItemIndex}
						className={classes.lineItemGroup}
						style={{ alignItems: 'center' }}
					>
						<FMPQuickbooksFreightAccountSelect
							{...this.setForm(`${pathPrefix}.quickbooksAccountId`)}
							label={'QB Freight Account'}
							md={6}
						/>

						<FMPText
							{...this.setForm(`${pathPrefix}.amount`)}
							label={'Total freight cost'}
							md={6}
						/>
						<Grid item xs={12} md={6}>
							<strong>Internal Accounting</strong>
							<br />
							Amount of total that is demurrage
						</Grid>
						<FMPText
							{...this.setForm(`${pathPrefix}.demurrageAmount`)}
							label={'Demurrage'}
							md={6}
						/>
					</Grid>
				);
			})}
		</Grid>
	);
}

export function save({ apIngestionResultId, callback }) {
	const { addVendorBill, updateVendorBill } = this.props;

	//- we do not support Updates...yet...ever?
	const { isUpdate, vendorBillId } = this.state;

	//- Required fields
	const formFieldError = {};
	const errors = [];

	const _setError = (path, error) => {
		_.set(formFieldError, path, error);
		errors.push(error);
	};

	const {
		typeOfBill,
		carrierId,
		supplierId,
		quickbooksVendorId,
		quickbooksTermId,
		billNumber,
		billDate,
		vendorBillOrders,
	} = this.state;

	let fields = [
		{ path: 'typeOfBill', display: 'Type of bill' },
		{ path: 'quickbooksVendorId', display: 'Vendor quickbooks link' },
		{ path: 'quickbooksTermId', display: 'Terms' },
		{ path: 'billDate', display: 'Bill date' },
		{ path: 'billNumber', display: 'Bill number' },
	];

	if (typeOfBill === 'fuel') {
		fields.push({ path: 'supplierId', display: 'Supplier vendor' });
	} else {
		fields.push({ path: 'carrierId', display: 'Carrier vendor' });
	}

	if (!_.isArray(vendorBillOrders)) {
		return callback(['You have to have at least one order']);
	}

	//- Order validation
	//let orderTotal = 0;
	if (typeOfBill === 'freight') {
		vendorBillOrders.forEach((vendorBillOrder, orderIndex) => {
			let prefix = `vendorBillOrders.${orderIndex}`;
			fields.push({ path: `${prefix}.carrierPoNumber`, display: 'Carrier PO NUmber' });

			const { vendorBillOrderLineItems, carrierPoNumberToInvoiceIdHash } = vendorBillOrder;
			if (!_.isArray(vendorBillOrderLineItems)) {
				errors.push(`Need at least one line item on order ${orderIndex}`);
				return;
			}

			vendorBillOrder.carrierPoNumberToInvoiceIds = [];
			if (_.isObject(carrierPoNumberToInvoiceIdHash)) {
				_.forEach(carrierPoNumberToInvoiceIdHash, (value, key) => {
					if (!value) {
						return;
					}
					vendorBillOrder.carrierPoNumberToInvoiceIds.push(parseInt(key, 10));
				});
			}

			if (
				!_.isEmpty(vendorBillOrder.carrierPoNumberToInvoiceIds) &&
				vendorBillOrder.isRackToRackTransfer
			) {
				errors.push(`You cant link the order AND mark it as a rack to rack transfer`);
				return;
			}

			if (vendorBillOrder.linkedBulkDeliveryId) {
				vendorBillOrder.linkedBulkDeliveryId = parseInt(vendorBillOrder.linkedBulkDeliveryId, 10);
			}

			vendorBillOrderLineItems.forEach((vendorBillOrderLineItems, lineItemIndex) => {
				const liPrefix = `${prefix}.vendorBillOrderLineItems.${lineItemIndex}`;
				fields.push({ path: `${liPrefix}.quickbooksAccountId`, display: 'Quickbooks Account' });
				fields.push({ path: `${liPrefix}.amount`, display: 'Freight cost' });
			});
		});
	} else if (typeOfBill === 'fuel') {
		vendorBillOrders.forEach((vendorBillOrder, orderIndex) => {
			let prefix = `vendorBillOrders.${orderIndex}`;
			fields.push({ path: `${prefix}.bolNumber`, display: 'BOL NUmber' });

			const { vendorBillOrderLineItems, bolNumberToInvoiceIdHash } = vendorBillOrder;
			if (!_.isArray(vendorBillOrderLineItems)) {
				errors.push(`Need at least one line item on order ${orderIndex}`);
				return;
			}

			vendorBillOrder.bolNumberToInvoiceIds = [];
			if (_.isObject(bolNumberToInvoiceIdHash)) {
				_.forEach(bolNumberToInvoiceIdHash, (value, key) => {
					if (!value) {
						return;
					}
					vendorBillOrder.bolNumberToInvoiceIds.push(parseInt(key, 10));
				});
			}

			// Preserve linkedRailcarId if set (railcar-linked order)
			if (vendorBillOrder.linkedRailcarId) {
				vendorBillOrder.linkedRailcarId = parseInt(vendorBillOrder.linkedRailcarId, 10);
			}

			if (
				!_.isEmpty(vendorBillOrder.bolNumberToInvoiceIds) &&
				vendorBillOrder.isInventoryTransfer
			) {
				errors.push(`You cant link the order AND mark it as an inventory transfer`);
				return;
			}

			vendorBillOrderLineItems.forEach((vendorBillOrderLineItem, lineItemIndex) => {
				const liPrefix = `${prefix}.vendorBillOrderLineItems.${lineItemIndex}`;
				fields.push({ path: `${liPrefix}.quickbooksItemId`, display: 'QB Item' });
				fields.push({ path: `${liPrefix}.quantity`, display: 'Quantity' });
				fields.push({ path: `${liPrefix}.unitPrice`, display: 'Unit Price' });

				const { quantity, unitPrice } = vendorBillOrderLineItem;
				if (quantity && unitPrice) {
					vendorBillOrderLineItem.amount = accounting.unformat(
						accounting.formatMoney(quantity * unitPrice)
					);
					//orderTotal += vendorBillOrderLineItem.amount;
				}
			});
		});
	}

	fields.forEach((s) => {
		if (!_.get(this.state, s.path)) {
			_setError(s.path, `${s.display} is required`);
		}
	});

	if (!_.isEmpty(errors)) {
		this.setState({ formFieldError });
		return callback(errors);
	}

	//- Validate the vendorBillOrders
	//- NOte we don't require a matching stationInvoice ID right now because it might be there
	//- and we don't want to hold up the bill but we mark it that way

	//- Lock and load
	const params = {
		typeOfBill,
		quickbooksVendorId,
		quickbooksTermId,
		billNumber,
		billDate,
		vendorBillOrders,
		apIngestionResultId,
	};

	if (typeOfBill === 'fuel') {
		params.supplierId = supplierId;
	} else if (typeOfBill === 'freight') {
		params.carrierId = carrierId;
	} else {
		return callback(['Type of bill is incorrect']);
	}

	//
	//- Get the right bill document
	//
	const { splitBillPageId, vendorDocumentResource, vendorCsvResource } = this.state;
	const { splitBillPages, resourceMap } = this.props;
	if (splitBillPageId) {
		if (_.isEmpty(splitBillPages) || _.isObject(resourceMap)) {
			/** @namespace splitBillPage.billName **/
			const splitBillPage =
				_.find(splitBillPages, { splitBillPageId: parseInt(splitBillPageId) }) || {};
			const resource = resourceMap[splitBillPage.resourceId] || {};

			params.splitBillPageId = splitBillPageId;
			params.vendorDocumentResourceId = resource.resourceId;
		}
	} else if (vendorDocumentResource) {
		params.vendorDocumentResourceId = vendorDocumentResource.resourceId;
	} else if (vendorCsvResource) {
		params.vendorCsvResourceId = vendorCsvResource.resourceId;
	}

	if (!params.vendorDocumentResourceId && !params.vendorCsvResourceId) {
		return callback(['A bill document/csv is required']);
	}

	this.setState({
		isSavingOpen: true,
		savingStatus: 'saving',
	});

	if (!isUpdate) {
		addVendorBill({
			params,
			callback,
		});
	} else {
		params.vendorBillId = vendorBillId;
		updateVendorBill({
			params,
			callback,
		});
	}
}
